module.exports = __webpack_public_path__ + "img/p-5.56a4ecb2.jpg";